var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"popup error-login_popup"},[_c('img',{attrs:{"src":require("../../../assets/error_icon.svg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.error(_vm.message))+" "),_c('close-btn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }